import { withErrorBoundary } from "@sentry/nextjs";
import cn from "classnames";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Features4PartnersContent } from "types/graphql/generated";
import { Partner } from "./Partner";

interface Props {
  className?: string;
  content: {
    partners: Features4PartnersContent[];
  };
}

const Partners: VFC<Props> = withErrorBoundary(({ className = "", content: { partners } }) => {
  return (
    <StyledPartners className={cn(className)}>
      <ul className="Partners__innerContainer">
        {partners.map((partner) => (
          <Partner key={partner.partnerName} className="Partner" content={partner} />
        ))}
      </ul>
    </StyledPartners>
  );
}, {});

const StyledPartners = styled.div`
  .Partners__innerContainer {
    display: flex;
    flex-wrap: wrap;
    margin-left: -24px;
    margin-top: -24px;
  }
`;

gql`
  fragment Features4PartnersContent on ComponentNestedFeatures4Partners {
    ...Features4PartnerContent
  }
`;

export { Partners };
